import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { useLayout } from '../contexts/LayoutContext';

export default function TabsBar() {
    const { tabs, removeTab, activeTabId, setActiveTabId } = useLayout();
    const navigate = useNavigate();
    const location = useLocation();

    // Sync activeTabId with current location
    useEffect(() => {
        if (location.pathname !== activeTabId) {
            setActiveTabId(location.pathname);
        }
    }, [location.pathname, setActiveTabId, activeTabId]);

    const handleTabClick = (path) => {
        navigate(path);
    };

    const handleCloseTab = (e, path) => {
        e.stopPropagation(); // Prevenir navegación

        removeTab(path);

        // Si cerramos la pestaña activa, navegar a la anterior o al dashboard
        if (path === activeTabId) {
            const index = tabs.findIndex(t => t.path === path);
            if (tabs.length > 1) {
                // Ir a la de la izquierda si hay, o si no a la de la derecha (index 0)
                const nextTab = index > 0 ? tabs[index - 1] : tabs[1];
                navigate(nextTab.path);
            } else {
                navigate('/');
            }
        }
    };

    if (tabs.length === 0) return null;

    return (
        <div className="flex items-center px-4 pt-2 bg-[#d8d8d8] border-b border-gray-300 overflow-x-auto mdi-scrollbar sticky top-16 z-30">
            {tabs.map((tab) => {
                const isActive = tab.path === activeTabId;
                return (
                    <div
                        key={tab.path}
                        onClick={() => handleTabClick(tab.path)}
                        className={`
                            group flex items-center h-9 px-4 mr-1 min-w-[120px] max-w-[200px] 
                            cursor-pointer transition-all duration-200 ease-in-out select-none
                            ${isActive
                                ? 'bg-white text-green-800 rounded-t-lg font-medium shadow-[0_-2px_4px_rgba(0,0,0,0.05)] border-t border-l border-r border-gray-200'
                                : 'bg-[#e5e7eb] text-gray-600 rounded-t-md hover:bg-[#f3f4f6] mt-1 hover:mt-0'}
                        `}
                    >
                        {/* Tab Title */}
                        <span className="truncate text-xs tracking-wide flex-1 mr-2" title={tab.title}>
                            {tab.title}
                        </span>

                        {/* Close Icon */}
                        <button
                            onClick={(e) => handleCloseTab(e, tab.path)}
                            className={`p-1 rounded-full opacity-60 hover:opacity-100 transition-opacity focus:outline-none ${isActive ? 'hover:bg-gray-100' : 'hover:bg-gray-200'
                                }`}
                        >
                            <X className={`w-3 h-3 ${isActive ? 'text-gray-500' : 'text-gray-400'}`} />
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
